"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledPropertyCardFlexWrapper = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _PropertyCardFlexWrapperMixin = require("../../mixins/components/PropertyCardFlexWrapperMixin");
var StyledPropertyCardFlexWrapper = /*#__PURE__*/_styledComponents.default.div.withConfig({
  displayName: "StyledPropertyCardFlexWrapper",
  componentId: "c11n-8-107-0__sc-38h0t9-0"
})(["", ""], _PropertyCardFlexWrapperMixin.PropertyCardFlexWrapperMixin);
exports.StyledPropertyCardFlexWrapper = StyledPropertyCardFlexWrapper;